import type { ComponentContentSchema } from '@vibesites/runtime';
import { useBlockSlot, SectionContextProvider, EditableToken } from '@vibesites/runtime/react';

/**
 * The Engrain sightmap inset by the page gutter: the iframe captures scroll, so the side margins
 * stay as a strip visitors can always scroll the page on. The gutter narrows on phones.
 * On phones the iframe is capped below the viewport height so the page stays reachable above and
 * below it; this overrides the block's Height token, which still applies on larger screens.
 */
export function EngrainSitemapEmbed() {
  const slot = useBlockSlot('engrainsitemapembed.map', { defaultValue: 'engrain-sitemap' });

  return (
    <section className="bg-[--q-paper] px-[--gutter] pb-16 max-[767px]:pb-10" id="sightmap">
      <EditableToken
        path="engrainsitemapembed.map"
        type="block"
        as="div"
        className="block w-full overflow-hidden rounded-lg border border-[--q-border] max-[767px]:[&_iframe]:h-[min(560px,70svh)]"
      >
        {slot ? (
          <SectionContextProvider sectionId={slot.sectionId}>
            <slot.BlockComponent sectionId={slot.sectionId} />
          </SectionContextProvider>
        ) : (
          <div className="section__note">No map selected</div>
        )}
      </EditableToken>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'EngrainSitemapEmbed',
  displayName: 'Engrain Sightmap',
  tokens: {
    'engrainsitemapembed.map': {
      label: 'Sightmap',
      type: 'block',
      defaultValue: 'engrain-sitemap',
      acceptedBlockCategories: ['Embeds'],
    },
  },
};

(EngrainSitemapEmbed as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default EngrainSitemapEmbed;
